import "./consultation.css";
import { useHomeContent } from "../../hooks/useHomeContent";
import { FeedbackForm } from "../../../../components/landing/forms/FeedbackForm/FeedbackForm";

export const Consultation = () => {
  const data = useHomeContent();
  if (!data?.consultation) return null;

  const c = data.consultation;
  const submitLabel =
    c.submitLabel ?? data?.feedbackModal?.submitLabel ?? data?.common?.send ?? "Send";

  return (
    <section className="oc-cons" style={{ backgroundImage: `url(${c.bg})` }}>
      <div className="oc-cons__overlay" />

      <div className="oc-container oc-cons__grid">
        <div
          className="oc-cons__text"
          dangerouslySetInnerHTML={{ __html: c.textHtml }}
        />

        <div className="oc-cons__card">
          <FeedbackForm
            thanksText={c.thanksText}
            submitLabel={submitLabel}
            showTender
            copy={data.feedbackForm}
          />
        </div>
      </div>
    </section>
  );
};
